<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            ویرایش
            <strong v-text="$lang.exercise_algorithm_detail"></strong>
            {{ $lang.execution_stage_title }} <b>{{ title }}</b>
          </div>
          <activityFrom
            v-if="itemAlgorithmDetail"
            :item="itemAlgorithmDetail"
            :isLoading="!isLoading"
            :showStateDefineCombo="false"
            :permissionBtn="true"
            @submit="save"
            @cancel="handleBack"
            :showUpload="true"
            :keyServies="`exercise`"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import activityFrom from "./../../../forms/activityFrom";
import { addAttachmentCode } from "@/components/ckeditor/submitAttachment";
export default {
  name: "add-exercise_algorithm_detail",
  components: {
    activityFrom,
  },
  props: {
    mode: {
      type: String,
      default: "add",
    },
    title: {
      type: String,
      default: "",
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    entityId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      exercise_id: this.$route.params.id,
      algorithm_id: this.$route.params.algorithm_id,
      duration: "",
      permission: [],
      allowPermissions: ["admin", "edit"],
      showPermissionButton: false,
      defaultValue: null,
      itemAlgorithmDetail: {},
    };
  },
  methods: {
    changeDefualt(event) {
      this.defaultValue = event == true ? "1" : "0";
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.caption = null;
      this.duration = "";
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },

    save(payload, allowAddAttachmentCode = true) {
      this.isLoading = true;

      this.$httpService
        .put(
          this.$config.api_url +
            this.$config.kanoon.activity
              .replace("{0}", "exercise_algorithm")
              .replace("{1}", this.algorithm_id) +
            "/" +
            this.entityId,
          payload
        )
        .then(async (response) => {
          this.$notify.success(response.data.message);

          if (allowAddAttachmentCode) {
            let res = await addAttachmentCode(
              "exercise_algorithm",
              this.entityId,
              payload.description
            );
            if (res.fail_codes) {
              payload.description = res.description;
              await this.save(payload, false);
            }
            this.afterSave();
          } else {
            this.afterSave();
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.$generateError(error);
        });
    },
    fetchData() {
      this.isLoading = true;
      if (isNaN(this.exercise_id)) {
        this.$notify.error("Not a number!");
        return false;
      }

      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.kanoon.activity
              .replace("{0}", "exercise_algorithm")
              .replace("{1}", this.algorithm_id) +
            "/" +
            this.entityId
        )
        .then((response) => {
          let data = response.data.data;
          this.itemAlgorithmDetail = data;

          this.isLoading = false;
          return true;
        })
        .catch((err) => {
          // this.$notify.error(err.response.message);
          this.$notify.error(err.message);
          return false;
        });
    },
    PermissionButtons() {
      this.permission.map((x) => {
        if (this.allowPermissions.includes(x)) {
          this.showPermissionButton = true;
        }
      });
    },
  },
  created() {
    this.fetchData()
      .then(() => this.PermissionButtons())
      .finally(() => {});
  },
  watch: {},
};
</script>

<style lang="css">
.main .container-fluid {
  padding: 0 10px !important;
}
</style>
